import Rest from '../rest'

/******************************************************************************
 *  Products
 *****************************************************************************/

/**
 * @type {Notifications}
 */
export default class Notifications extends Rest {

    constructor () {
        super('/notification')
    }

    noRead() {
        return this.http.get(this.constructor.normalize(this.resource, 'noRead'))
    }

    destroy(id) {
        return this.http.delete(this.constructor.normalize(this.resource, 'destroy/?id=' + id))
    }

    markAll() {
        return this.http.put(this.constructor.normalize(this.resource, 'markAllRead'))
    }

    store() {
        return this.http.get(this.resource)
    }
}